import { DatePipe, DATE_PIPE_DEFAULT_TIMEZONE } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({ name: 'localDate' })
export class LocalDatePipe implements PipeTransform {
    constructor(private dPipe: DatePipe) {
    }

    transform(value?: number) {
        if (!value) {
            return null;
        }
        return this.dPipe.transform(new Date(value), 'M/d/yyyy');
    }
}

@Pipe({ name: 'localDateTime' })
export class LocalDateTimePipe implements PipeTransform {
    constructor(private dPipe: DatePipe) {
    }

    transform(value?: number) {
        if (!value) {
            return null;
        }
        return this.dPipe.transform(new Date(value), 'M/d/yyyy \'at\' h:mma');
    }
}

@Pipe({ name: 'localPrettyDate' })
export class LocalPrettyDatePipe implements PipeTransform {
    constructor(private dPipe: DatePipe) {
    }

    transform(value?: number) {
        if (!value) {
            return null;
        }
        return this.dPipe.transform(new Date(value), 'MMM d, yyyy');
    }
}

@Pipe({ name: 'localPrettyTime' })
export class LocalPrettyTimePipe implements PipeTransform {
    constructor(private dPipe: DatePipe) {
    }

    transform(value?: number) {
        if (!value) {
            return null;
        }
        return this.dPipe.transform(new Date(value), 'h:mm a');
    }
}

@Pipe({ name: 'localPrettyDateTime' })
export class LocalPrettyDatePipeTime implements PipeTransform {
    constructor(private dPipe: DatePipe) {
    }

    transform(value?: number) {
        if (!value) {
            return null;
        }
        return this.dPipe.transform(new Date(value), 'MMMM d, yyyy h:mma z');
    }
}

@Pipe({ name: 'cfDateTime' })
export class CFDateTimePipe implements PipeTransform {
    constructor(private dPipe: DatePipe) {
    }

    transform(value?: string) {
        if (!value) {
            return null;
        }
        return this.dPipe.transform(new Date(value), 'M/d/yyyy');
    }
}

@Pipe({ name: 'ordinal' })
export class OrdinalPipe implements PipeTransform {
    constructor() {
    }

    transform(value?: number) {
        if (!value) {
            return null;
        }
        if (value.toString().endsWith('11')) { return value.toString() + 'th'; }
        if (value.toString().endsWith('12')) { return value.toString() + 'th'; }
        if (value.toString().endsWith('13')) { return value.toString() + 'th'; }
        if (value.toString().endsWith('1')) { return value.toString() + 'st'; }
        if (value.toString().endsWith('2')) { return value.toString() + 'nd'; }
        if (value.toString().endsWith('3')) { return value.toString() + 'rd'; }
        return value.toString() + 'th';
    }
}

@Pipe({ name: 'phone' })
export class PhoneNumberPipe implements PipeTransform {
    constructor(private dPipe: DatePipe) {
    }

    transform(value?: string) {
        if (!value) {
            return null;
        }

        if (value.length == 10 && /^\d+$/.test(value)) {
            return value.substring(0, 3) + '-' + value.substring(3, 6) + '-' + value.substring(6);
        } else if (value.length > 10 && /^\d+$/.test(value.substring(0, 10))) {
            return value.substring(0, 3) + '-' + value.substring(3, 6) + '-' + value.substring(6);
        } else if (value.length == 7 && /^\d+$/.test(value)) {
            return value.substring(0, 3) + '-' + value.substring(3);
        }
        return value;
    }
}

@Pipe({ name: 'callable' })
export class CallablePhoneNumberPipe implements PipeTransform {
    constructor(private dPipe: DatePipe) {
    }

    transform(value?: string) {
        if (!value) {
            return null;
        }

        var retVal = '';
        for (var i = 0; i < value.length; i++) {
            if ('0123456789'.indexOf(value[i]) >= 0) {
                retVal += value[i];
                continue;
            } else if ('()-. '.indexOf(value[i]) >= 0) {
                continue;
            } else if (value[i] === '+' && retVal.length === 0) {
                continue;
            }
            break;
        }
        if (retVal.length === 11 && retVal.startsWith('1')) {
            retVal = retVal.substring(1);
        }

        if (retVal.length !== 10) {
            return null;
        }

        return retVal;
    }
}

@Pipe({
    name: 'search'
}) export class SearchFilterPipe implements PipeTransform {
    transform(data: any[], filter: string): any {
        if (!data || !filter) {
            return data;
        }
        return data.filter(obj => {
            var words = filter.split(' ').filter(f => { return f.trim().length > 0; });
            return words.reduce((acc, word) => {
                return acc && (Object.keys(obj).filter(p => { return typeof (obj[p]) == 'string' && obj[p].toLowerCase().includes(word.trim().toLowerCase()); }).length > 0);
            }, true);
            /*
            console.log(obj);
            return Object.keys(obj).reduce((acc, curr) => {
                console.log(acc);
                console.log(filter);
                console.log(curr);
                var foundWords = words.filter(f => { return typeof (obj[curr]) == 'string' && obj[curr].toLowerCase().includes(f.trim().toLowerCase()); });
                return acc || (foundWords.length == words.length);
            }, false);
            */
        });
    }
}

@Pipe({
    name: 'fcn'
}) export class FunctionFilterPipe<T> implements PipeTransform {
    transform(data: T[], compare: T, callback: (x: T, c: T) => boolean): any {
        if (!data || !callback) {
            return data;
        }
        return data.filter(obj => callback(obj, compare));
    }
}

@Pipe({
    name: 'fcnSearch'
}) export class FunctionSearchPipe<T> implements PipeTransform {
    transform(data: T[], compare: string, callback: (x: T, c: string) => boolean): any {
        if (!data || !callback) {
            return data;
        }
        return data.filter(obj => callback(obj, compare));
    }
}

@Pipe({
    name: 'join'
}) export class JoinPipe implements PipeTransform {
    transform(input: Array<any>, sep = ', '): string {
        return input.join(sep);
    }
}

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(private domSanitizer: DomSanitizer) { }
    transform(url: string) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

@Pipe({
    name: 'filter',
    pure: false,
}) export class ObjectFilterPipe implements PipeTransform {
    transform(data: any[], filter: any): any {
        if (!data || !filter) {
            return data;
        }
        //console.log(filter);
        return data.filter(obj => {
            return Object.keys(filter).reduce((acc, curr) => {
                //                console.log(obj);
                //                console.log(obj.hasOwnProperty(curr) ? 'has ' + curr + ' ' + obj[curr] : 'missing ' + curr);
                if (filter[curr] === null || filter[curr] === undefined) {
                    return acc;
                } else if (typeof filter[curr] == 'string') {
                    return obj.hasOwnProperty(curr) ? acc || (obj[curr] || '').toLowerCase().indexOf(filter[curr].toLowerCase()) >= 0 : false;
                } else {
                    return obj.hasOwnProperty(curr) ? acc || obj[curr] === filter[curr] : false;
                }
            }, false);
        });
    }
}

@Pipe({
    name: 'orFilter',
    pure: false,
}) export class ObjectOrFilterPipe implements PipeTransform {
    transform(data: any[], filter: any): any {
        /* | orFilter : { fields: ['field1', 'field2', ...], value: 'string to search for' } */
        /* each string inside .value must be found at least once in at least one of the properties in .fields */
        if (!data || !filter) {
            return data;
        }
        //console.log(filter);
        return data.filter(obj => {
            if (!filter.value) {
                return true;
            }
            var retVal: boolean = true;
            (filter.value as string).split(' ').forEach((s: string) => {
                var hasWord: boolean = false;
                if (s) {
                    filter.fields.forEach((f: string) => {
                        if (obj.hasOwnProperty(f)) {
                            hasWord = hasWord || ((obj[f] || '').toLowerCase().indexOf(s.toLowerCase()) >= 0);
                        }
                    });
                    retVal = retVal && hasWord;
                }
            });
            return retVal;
        });
    }
}
